import { Field, Form } from '@balance-web/forms';

export const isForm = (value: any): value is Form<Field> => {
  return !!value._field && value.value !== undefined;
};
